export const ADD_SUPERUSER= 'ADD_SUPERUSER'
export const ADD_SUPERUSER_SUCCESS= 'ADD_SUPERUSER_SUCCESS'
export const ADD_SUPERUSER_ERROR='ADD_SUPERUSER_ERROR'

export const AddSuperUser= (data) => ({
    type: ADD_SUPERUSER,
    payload: data
})